/* unplugin-vue-components disabled */import { render } from "./ContactModal.vue?vue&type=template&id=27a36676&scoped=true"
import script from "./ContactModal.vue?vue&type=script&lang=js"
export * from "./ContactModal.vue?vue&type=script&lang=js"

import "./ContactModal.vue?vue&type=style&index=0&id=27a36676&scoped=true&lang=css"
import "./ContactModal.vue?vue&type=style&index=1&id=27a36676&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27a36676"]])

export default __exports__